import GlobalEffects from './GlobalEffects';

export default GlobalEffects;
